import api from '../utils/api';

const BASE = '/api/profile-stats';

/**
 * Get profile stats of the creator the user is viewing
 * @route GET /api/profile-stats/:creatorId
 * @param {string} creatorId
 * @returns {Promise<{averageRating: number, scenarioCount: number, totalViews: number}>}
 */
export const getProfileStats = (creatorId) =>
    api.get(`${BASE}/${creatorId}`).then((r) => r.data);